import React from "react"
import { Calendar } from "./images/Calendar"
import { Card } from "./images/Card"
import { Coin } from "./images/Coin"
import { Percent } from "./images/Percent"

export const variantConfig = {
  base: [
    {
      title: "С подпиской «Халва.Десятка»",
      benefits: [
        {
          smallText: "кешбэк",
          bigText: "до 10%",
          Icon: Percent,
          alt: "Percent",
        },
        {
          smallText: "срок рассрочки",
          bigText: <>от 10 до 24 месяцев во&nbsp;всех магазинах-партнерах</>,
          Icon: Calendar,
          alt: "Calendar",
        },
        {
          smallText: "ставка по вкладку",
          bigText: "до +5%",
          Icon: Coin,
          alt: "Coin",
        },
        {
          smallText: "стикер",
          bigText: "бесплатно",
          Icon: Card,
          alt: "Card",
        },
      ],
      buttonText: "Попробовать бесплатно",
      buttonVariant: "contained",
    },
    {
      title: "Без подписки «Халва.Десятка»",
      benefits: [
        {
          smallText: "кешбэк",
          bigText: "до 5%",
          Icon: Percent,
          alt: "Percent",
        },
        {
          smallText: "срок рассрочки",
          bigText: (
            <>
              от 1 до 24 месяцев <br className="d-ld-none" /> (в зависимости{" "}
              <br className="d-ld-none" />
              от&nbsp;магазина-партнера)
            </>
          ),
          Icon: Calendar,
          alt: "Calendar",
        },
        {
          smallText: "ставка по вкладку",
          bigText: "стандартная",
          Icon: Coin,
          alt: "Coin",
        },
        {
          smallText: "стикер",
          bigText: "999 рублей",
          Icon: Card,
          alt: "Card",
        },
      ],
      buttonText: "Оформить карту",
      buttonVariant: "outlined",
    },
  ],
}
